import Draggable from 'Draggable'
import 'ThrowPropsPlugin'
import { bus } from '@/consts'
import { TweenMax, Power3 } from 'gsap'

export default {
  name: 'DragToAdvance',
  template: '#drag-to-advance-template',
  data () {
    return {
      uiSliderWidth: 0,
      dragElWidth: 0,
      dragging: false,
      dragDirection: '',
      xPos: 0,
      draggable: null
    }
  },
  props: ['teamCount', 'dragAreaWidth'],
  computed: {
    classObj () {
      return {
        'ui-slider--dragging': this.dragging,
        'ui-slider--dragging-right': this.dragging && this.dragDirection === 'right',
        'ui-slider--dragging-left': this.dragging && this.dragDirection === 'left'
      }
    }
  },
  methods: {
    createDragUi () {
      this.uiSliderWidth = this.$refs.uiSlider.offsetWidth
      this.dragElWidth = this.$refs.dragEl.offsetWidth
      let vm = this

      this.draggable = Draggable.create(this.$refs.dragEl, {
        type: 'x',
        bounds: this.$refs.uiSlider,
        throwProps: true,
        throwResistance: 9999999999999,
        dragResistance: 0.3,
        minDuration: 0,
        overshootTolerance: 0,
        onDrag: function () {
          vm.$emit('dragEvent', this)
          vm.setDragDirection(this.x)
        },
        onThrowUpdate: function () {
          vm.$emit('throwEvent', this)
          vm.setDragDirection(this.x)
        },
        onPress: function () {
          vm.dragging = true
        },
        onRelease: function () {
          vm.dragging = false
          vm.dragDirection = ''
        },
        snap: {
          x: function (value) {
            // snap to end if the dragEl has reached 80% progress or greater
            if (Math.round(value > this.maxX * 0.8)) {
            }
            return Math.round(value > this.maxX * 0.8 ? this.maxX : value)
          }
        }
      })
    },
    setDragDirection (xPos) {
      if (xPos > this.xPos) {
        this.dragDirection = 'right'
      } else if (xPos > 0 && xPos < this.xPos) {
        this.dragDirection = 'left'
      } else {
        this.dragDirection = ''
      }
      this.xPos = xPos
    },
    fullAnimation () {
      this.draggable[0].disable()
      TweenMax.to(this.$refs.dragEl, 1, { x: this.uiSliderWidth - this.dragElWidth, ease: Power3.easeOut })
      bus.$emit('bracketFullAnimation')
    }
  },
  mounted () {
    this.createDragUi()
  }
}



// WEBPACK FOOTER //
// ./src/components/DragToAdvance.js